import { XS } from "constants/sizes";
import ProductSignUp from "segments/desktop/core-components/product-sign-up/product-sign-up";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { CRM_MINI_SITE_LINK, SOFTWARE_MINI_SITE_LINK, WORK_MANAGEMENT_MINI_SITE_LINK } from "constants/links";
import { StyledProductSignupButton } from "./product-signup-button.scss";

const PRODUCT_TO_MINI_SITE_URL = {
  [CRM_PRODUCT_ID]: CRM_MINI_SITE_LINK,
  [DEV_PRODUCT_ID]: SOFTWARE_MINI_SITE_LINK,
  [WORK_MANAGEMENT_PRODUCT_ID]: WORK_MANAGEMENT_MINI_SITE_LINK
};

const ProductSignupAndLearnMoreButtons = ({ translate, withArrow, ...button }) => (
  <StyledProductSignupButton className="product-signup-wrapper">
    <ProductSignUp withButtonArrow={withArrow} {...button} buttonSize={XS} />
    <SecondaryButton
      isWithArrow={withArrow}
      url={PRODUCT_TO_MINI_SITE_URL[button?.productType]}
      color={button?.buttonColor}
      buttonText={translate("signup.learnMore")}
      isOpenLinkInNewTab
    />
  </StyledProductSignupButton>
);

export default ProductSignupAndLearnMoreButtons;
